module.exports = {"medicaid":{}}


//////////////////
// WEBPACK FOOTER
// ./src/data/ranking/R2.json
// module id = 331
// module chunks = 143196823979170 184088790168614